import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchProfiles = createAsyncThunk(
  "profiles/fetchProfiles",
  async (_, thunkAPI) => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        "https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/profile/GetAllProfiles",
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (!res.ok) {
        throw new Error(`Error: ${res.status}`);
      }
      const data = await res.json();

      const sortedProfiles = (data.profiles || data).sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      return sortedProfiles;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

const profileSlice = createSlice({
  name: "profiles",
  initialState: {
    profiles: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfiles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfiles.fulfilled, (state, action) => {
        state.loading = false;
        state.profiles = action.payload;
      })
      .addCase(fetchProfiles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default profileSlice.reducer;
